"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@remirror/react");
const react_components_1 = require("@remirror/react-components");
const FormatClearRounded_1 = __importDefault(require("@mui/icons-material/FormatClearRounded"));
const Button_1 = __importDefault(require("../../../ui/Button/Button"));
const getShortcutSymbol_1 = require("../../../utils/getShortcutSymbol");
const ClearFormattingButton = () => {
    const { clearFormatting } = (0, react_2.useCommands)();
    const { selection } = (0, react_2.useEditorState)();
    // Checks wether we have specific content selected or not
    const contentSelected = !selection.empty;
    const handleSelect = () => {
        if (clearFormatting.enabled()) {
            clearFormatting();
        }
    };
    const handleShortcut = (0, react_1.useCallback)(() => {
        handleSelect();
        // Prevent other key handlers being run
        return true;
    }, []);
    // When Ctrl+\ is pressed clear formatting, only registered in the toolbar button instance to avoid the key press
    // being double handled.
    (0, react_2.useKeymap)('Mod-\\', handleShortcut);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_components_1.VerticalDivider, null),
        react_1.default.createElement(Button_1.default, { handleOnClick: handleSelect, isDisabled: false, isActive: false, icon: react_1.default.createElement(FormatClearRounded_1.default, null), label: `${contentSelected ? 'Clear formatting from selection' : 'Clear all formatting'} (${(0, getShortcutSymbol_1.getShortcutSymbol)()}+\\)` })));
};
exports.default = ClearFormattingButton;
